import { useTranslation } from "react-i18next";
import { categories } from "@/mocks/categories";

const categoryImages: Record<string, string> = {
  "Shoes": "https://readdy.ai/api/search-image?query=Single%20white%20sneaker%20isolated%20on%20clean%20light%20background%20tiny%20product%20thumbnail%20minimal%20studio%20photography&width=80&height=80&seq=grid-shoes-x1&orientation=squarish",
  "Hoodies/Sweaters": "https://readdy.ai/api/search-image?query=Single%20gray%20hoodie%20folded%20neatly%20isolated%20on%20clean%20light%20background%20tiny%20product%20thumbnail%20minimal%20studio%20photography&width=80&height=80&seq=grid-hoodie-x2&orientation=squarish",
  "T-Shirts": "https://readdy.ai/api/search-image?query=Single%20white%20cotton%20t-shirt%20folded%20neatly%20isolated%20on%20clean%20light%20background%20tiny%20product%20thumbnail%20minimal%20studio%20photography&width=80&height=80&seq=grid-tshirt-x3&orientation=squarish",
  "Jackets": "https://readdy.ai/api/search-image?query=Single%20olive%20green%20jacket%20folded%20neatly%20isolated%20on%20clean%20light%20background%20tiny%20product%20thumbnail%20minimal%20studio%20photography&width=80&height=80&seq=grid-jacket-x4&orientation=squarish",
  "Pants/Shorts": "https://readdy.ai/api/search-image?query=Single%20pair%20of%20tailored%20beige%20pants%20folded%20neatly%20isolated%20on%20clean%20light%20background%20tiny%20product%20thumbnail%20minimal%20studio%20photography&width=80&height=80&seq=grid-pants-x5&orientation=squarish",
  "Headwear": "https://readdy.ai/api/search-image?query=Single%20stylish%20baseball%20cap%20isolated%20on%20clean%20light%20background%20tiny%20product%20thumbnail%20minimal%20studio%20photography&width=80&height=80&seq=grid-headwear-x6&orientation=squarish",
  "Sets": "https://readdy.ai/api/search-image?query=Single%20matching%20hoodie%20and%20sweatpants%20set%20folded%20together%20isolated%20on%20clean%20light%20background%20tiny%20product%20thumbnail%20minimal%20studio%20photography&width=80&height=80&seq=grid-sets-x7&orientation=squarish",
  "Underwear/Underpants": "https://readdy.ai/api/search-image?query=Single%20pair%20of%20folded%20underwear%20neatly%20arranged%20isolated%20on%20clean%20light%20background%20tiny%20product%20thumbnail%20minimal%20studio%20photography&width=80&height=80&seq=grid-underwear-x8&orientation=squarish",
  "Jersey": "https://readdy.ai/api/search-image?query=Single%20sports%20jersey%20folded%20neatly%20isolated%20on%20clean%20light%20background%20tiny%20product%20thumbnail%20minimal%20studio%20photography&width=80&height=80&seq=grid-jersey-x9&orientation=squarish",
  "Accessories": "https://readdy.ai/api/search-image?query=Single%20minimalist%20watch%20and%20bracelet%20accessory%20set%20arranged%20on%20clean%20light%20background%20tiny%20product%20thumbnail%20minimal%20studio%20photography&width=80&height=80&seq=grid-accessories-x10&orientation=squarish",
  "Bags": "https://readdy.ai/api/search-image?query=Single%20structured%20leather%20tote%20bag%20isolated%20on%20clean%20light%20background%20tiny%20product%20thumbnail%20minimal%20studio%20photography&width=80&height=80&seq=grid-bags-x11&orientation=squarish",
  "Belts": "https://readdy.ai/api/search-image?query=Single%20premium%20leather%20belt%20coiled%20neatly%20isolated%20on%20clean%20light%20background%20tiny%20product%20thumbnail%20minimal%20studio%20photography&width=80&height=80&seq=grid-belts-x12&orientation=squarish",
  "Perfumes": "https://readdy.ai/api/search-image?query=Single%20elegant%20perfume%20bottle%20isolated%20on%20clean%20light%20background%20tiny%20product%20thumbnail%20minimal%20studio%20photography&width=80&height=80&seq=grid-perfumes-x13&orientation=squarish",
  "Other Stuff": "https://readdy.ai/api/search-image?query=Single%20stylish%20sunglasses%20and%20keychain%20set%20arranged%20on%20clean%20light%20background%20tiny%20product%20thumbnail%20minimal%20studio%20photography&width=80&height=80&seq=grid-other-x14&orientation=squarish",
};

export default function CategoriesSection() {
  const { t } = useTranslation();

  const featuredCategories = categories.slice(0, 4);

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="mb-10">
          <span className="text-xs uppercase tracking-[0.2em] text-foreground-500 font-heading">
            {t("categories.subtitle")}
          </span>
          <h2 className="text-3xl md:text-4xl font-heading font-semibold text-foreground-950 mt-2">
            {t("categories.title")}
          </h2>
        </div>

        {/* Featured Category Cards */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-5 mb-10">
          {/* Shoes Card */}
          <a
            href="https://kaspreadsheet.com/category-911-Shoes.html"
            target="_blank"
            rel="noopener nofollow"
            className="group rounded-2xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all cursor-pointer"
          >
            <div className="aspect-[3/4] overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Single%20pair%20of%20luxury%20cream%20white%20leather%20sneakers%20with%20subtle%20embossed%20logo%20detail%20placed%20on%20light%20beige%20linen%20fabric%20background%20minimal%20overhead%20product%20photography%20clean%20modern%20composition%20soft%20diffused%20studio%20lighting%20elegant%20editorial%20style%20subtle%20shadow%20play%20high-end%20commercial%20quality%20neutral%20warm%20tones&width=600&height=800&seq=cat-shoes-v2-011&orientation=portrait"
                alt="Shoes"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-4">
              <h3 className="text-sm font-semibold text-foreground-900">Shoes</h3>
              <span className="text-xs text-primary-600 mt-1 block group-hover:underline">
                {t("categories.cta")} →
              </span>
            </div>
          </a>

          {/* Hoodies Card */}
          <a
            href="https://kaspreadsheet.com/search-912/name/Shoes.html"
            target="_blank"
            rel="noopener nofollow"
            className="group rounded-2xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all cursor-pointer"
          >
            <div className="aspect-[3/4] overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Premium%20heather%20gray%20oversized%20hoodie%20with%20drawstring%20detail%20laid%20flat%20on%20warm%20terracotta%20clay%20colored%20linen%20background%20minimal%20product%20photography%20soft%20folds%20and%20fabric%20texture%20visible%20gentle%20directional%20light%20casting%20subtle%20warm%20shadows%20clean%20elegant%20editorial%20composition%20modern%20streetwear%20aesthetic%20high%20quality%20commercial%20style&width=600&height=800&seq=cat-hoodie-v2-012&orientation=portrait"
                alt="Hoodies/Sweaters"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-4">
              <h3 className="text-sm font-semibold text-foreground-900">Hoodies/Sweaters</h3>
              <span className="text-xs text-primary-600 mt-1 block group-hover:underline">
                {t("categories.cta")} →
              </span>
            </div>
          </a>

          {/* T-Shirts Card */}
          <a
            href="https://kaspreadsheet.com/search-913/name/Shoes.html"
            target="_blank"
            rel="noopener nofollow"
            className="group rounded-2xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all cursor-pointer"
          >
            <div className="aspect-[3/4] overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Premium%20heavyweight%20white%20cotton%20t-shirt%20with%20relaxed%20oversized%20fit%20laid%20flat%20on%20sage%20green%20linen%20fabric%20background%20minimal%20product%20photography%20clean%20neckline%20and%20hem%20details%20visible%20soft%20natural%20window%20light%20from%20left%20side%20creating%20delicate%20shadows%20refined%20editorial%20composition%20understated%20luxury%20streetwear%20aesthetic%20high%20quality%20commercial%20style&width=600&height=800&seq=cat-tshirt-v2-013&orientation=portrait"
                alt="T-Shirts"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-4">
              <h3 className="text-sm font-semibold text-foreground-900">T-Shirts</h3>
              <span className="text-xs text-primary-600 mt-1 block group-hover:underline">
                {t("categories.cta")} →
              </span>
            </div>
          </a>

          {/* Jackets Card */}
          <a
            href="https://kaspreadsheet.com/search-914/name/Shoes.html"
            target="_blank"
            rel="noopener nofollow"
            className="group rounded-2xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all cursor-pointer"
          >
            <div className="aspect-[3/4] overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Premium%20sand%20colored%20lightweight%20trench%20coat%20with%20belt%20detail%20elegantly%20draped%20on%20light%20dove%20gray%20linen%20fabric%20background%20minimal%20fashion%20product%20photography%20soft%20folds%20and%20fabric%20movement%20visible%20gentle%20diffused%20studio%20lighting%20clean%20refined%20editorial%20composition%20sophisticated%20streetwear%20aesthetic%20high%20quality%20commercial%20style&width=600&height=800&seq=cat-jacket-v2-014&orientation=portrait"
                alt="Jackets"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-4">
              <h3 className="text-sm font-semibold text-foreground-900">Jackets</h3>
              <span className="text-xs text-primary-600 mt-1 block group-hover:underline">
                {t("categories.cta")} →
              </span>
            </div>
          </a>
        </div>

        {/* All Categories Grid */}
        <div className="mt-12">
          <h3 className="text-lg font-heading font-semibold text-foreground-800 mb-6">
            Todas as Categorias
          </h3>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3">
            {categories.map((cat) => (
              <a
                key={cat.name}
                href={cat.url}
                target="_blank"
                rel="noopener nofollow"
                className="group flex items-center gap-3 p-3 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-300 hover:bg-primary-50/30 transition-all cursor-pointer"
              >
                <div className="w-10 h-10 rounded-lg overflow-hidden bg-background-200 flex-shrink-0">
                  <img
                    src={categoryImages[cat.name]}
                    alt={cat.name}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                  />
                </div>
                <span className="text-sm font-medium text-foreground-700 group-hover:text-foreground-950 transition-colors">{cat.name}</span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}